import Vue from 'vue'
import Router from 'vue-router'
import Home from 'views/Home'
import JoinDate from 'views/JoinDate'
import LeaveDate from 'views/LeaveDate'
import Salary from 'views/Salary'
import Confirm from 'views/Confirm'
import Loading from 'views/Loading'
import Login from 'views/Login'
import KakaoLogin from 'views/KakaoLogin'
import Result from 'views/Result'
import PhoneValidate from 'views/PhoneValidate'
import PhoneResult from 'views/PhoneResult'
import Contract from 'views/Contract'
import SubmitResult from 'views/SubmitResult'
import Message from 'views/Message'
import Policy from 'views/Policy'
import Signup from 'views/Signup'
import PhoneValidate2 from 'views/PhoneValidate2'
import ContractUploadFile from 'views/ContractUploadFile'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/joinDate',
    component: JoinDate
  },
  {
    path: '/leaveDate',
    component: LeaveDate
  },
  {
    path: '/salary',
    component: Salary
  },
  {
    path: '/confirm',
    component: Confirm
  },
  {
    path: '/loading',
    component: Loading
  },
  {
    path: '/kakaoLogin',
    component: KakaoLogin
  },
  {
    path: '/result',
    component: Result
  },
  {
    path: '/phoneValidate',
    component: PhoneValidate
  },
  {
    path: '/phoneResult',
    component: PhoneResult
  },
  {
    path: '/contract/:uuid',
    component: Contract
  },
  {
    path: '/fileManage/:uuid',
    component: ContractUploadFile
  },
  {
    path: '/submitResult',
    component: SubmitResult
  },
  {
    path: '/message/:uuid',
    component: Message
  },
  {
    path: '/policy',
    component: Policy
  },
  {
    path: '/signup',
    component: Signup
  },
  {
    path: '/validatePhone',
    component: PhoneValidate2
  },
]
const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return savePosition
    } else {
      return {x:0,y:0}
    }
  }
})
export default router
